module.exports = __webpack_public_path__ + "img/help_outline.68e36314.svg";